module.exports = __webpack_public_path__ + "img/gb13871-92_18x35x7.prt.57df6623.jpg";